import { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import './auth.scss';

export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { signIn, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user, navigate]);

  // Add blur handler for iOS keyboard
  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    // Small delay to ensure iOS keyboard has time to dismiss
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    
    try {
      await signIn(email, password);
      navigate('/');
    } catch (error) {
      setError(error instanceof Error ? error.message : 'Invalid email or password');
      // Ensure error is visible on iOS
      setTimeout(() => {
        const errorElement = document.querySelector('.error-message');
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-header">
          <h1>Welcome Back! 👋</h1>
          <p className="tagline">Sign in to continue your PLAB2 journey</p>
        </div>

        <form onSubmit={handleSubmit} autoComplete="off">
          {error && <div className="error-message" role="alert">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onBlur={handleBlur}
              required
              placeholder="your.email@example.com"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck="false"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onBlur={handleBlur}
              required
              placeholder="Enter your password"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck="false"
            />
          </div>
          
          <button type="submit" className="submit-button">
            Sign In
          </button>
        </form>

        <Link 
          to="/forgot-password"
          className="forgot-password-link"
        >
          Forgot Password?
        </Link>
        
        <p className="auth-switch">
          New user?{' '}
          <Link to="/register"
          className="forgot-password-link"
          >➡️SignUp</Link>
        </p>
      </div>
    </div>
  );
} 